<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- :to="`/project-info/operation-activities-form`" -->
    <v-btn
      color="primary"
      dark
      slot="activator"
      class="mb-2"      
      @click="addNew"
      >New</v-btn>
    <v-card-title>
      <h2>Operation Activities</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

     <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>    
        <td class="text-xs-left">{{ props.item.project_name_short }}</td>
        <td class="text-xs-left">{{ props.item.project_name }}</td>
        <td class="text-xs-left">{{ props.item.project_code }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.project_approval_date) }}</td>
        <td class="text-xs-left">{{ changeFormateDMY(props.item.project_end_date) }}</td>
        <td class="text-xs-left">{{ props.item.total_project_value_usd | currency }}</td>
        <td class="text-xs-left">{{ props.item.total_project_value_bdt | currency }}</td>

        <td class="justify-center layout px-0">
          <v-btn title="View Details" icon class="mx-0" @click="viewDetails(props.item.id)">
            <v-icon color="teal">visibility</v-icon>
          </v-btn>

          <v-btn title="Edit" icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn title="Delete" icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>

           <v-btn title="Revision" icon class="mx-0" @click="revision(props.index, props.item)">                        
            <v-icon>rate_review</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    

  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import ServerPath from '../../../server-path/server-path';
import { preFix } from "../../../vuex/api";
import Axios from "axios";

export default {

  data: () => ({
    valid: true,
    dialog: false,
    dialogEditForm: false,

    selected: [],

    delete_id: "",
    row_index: "",
    dialog2: false,
    
    SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    select: null,
    typelist: [
      { name: "Type 1", id: 1 },
      { name: "Type 2", id: 2 },
      { name: "Type 3", id: 3 }
    ],

    formSchema: {
      id: 0,
      doner_no: "",
      doner_name: "",
      doner_type: "",
      in_short: ""
    },

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: '',
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      { text: "Project Name (Short Name)", align: "left", sortable: true, value: "project_name_short" },
      { text: "Project Name", align: "left", sortable: true, value: "project_name" },
      { text: "Project Code", align: "left", sortable: true, value: "project_code" },
      { text: "Start Date", align: "left", sortable: true, value: "project_approval_date" },
      { text: "End Date", align: "left", sortable: true, value: "project_end_date" },
      { text: "Project Value (USD)", align: "left", sortable: true, value: "total_project_value_usd" },
      { text: "Project Value (BDT)", align: "left", sortable: true, value: "total_project_value_bdt" },
      { text: "Action", align: "center", value: "" }
    ]
    /*############# /Datatable #############*/
  }),
  
  created(){
    var num = '332800000.4563';
    //var a = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    var a = num.toString(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    const amt = Number(num)
    var a = amt && amt.toLocaleString(undefined, {maximumFractionDigits:3}) || '0'
  },

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {          
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },


  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
          this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "operation-activities-info")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    viewDetails(id){
      let route = ServerPath.serverPath+'/details-ope-activities/'+id;
      window.open(route, '_blank');
    },

    revision(index, item)
    {
      sessionStorage.setItem("revision", item.id); 
      this.action_process(index, item);
    },

    editItem(index, item) {
      sessionStorage.removeItem('revision')   
      this.action_process(index, item)
    },

    action_process(index, item)
    {
      this.row_index = index;
      this.formSchema = item;         
      sessionStorage.setItem("operation_act_id", item.id);      
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$router.push('/project-info/operation-activities-form');
    },

    addNew(){
      this.remove_session();
      this.$router.push('/project-info/operation-activities-form');
    },

    remove_session()
    {
      sessionStorage.removeItem('operation_act_id')
      sessionStorage.removeItem('revision')
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      //console.log("row_index", row_index);
      commonService.deleteRow(id, "operation-activities").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
          this.SnackbarVal.color = "success";
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.confirmModel = false;
          this.dialog2 = false;
          this.remove_session();
          //this.getDataFromApi();
        } else {
          this.SnackbarVal.color = "error"; 
          this.SnackbarVal.message = "Try again!";
          this.SnackbarVal.snackbar = true;
        }


      });
    },

    close(res) {
      if (res.action == "add") {
        this.items.push(res.data);
      }
      if (res.action == "edit") {
        this.items[this.row_index] = res.data;
      }

      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
      
      this.row_index = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/operation_activities/operation_act_table.vue